import './main.css';
import Lenis from 'lenis';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css'; // Correct path for Swiper's CSS
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import menuDropdown from './src/js/menuDropdown';
import menuToggle from './src/js/menuToggle';
import modal from './src/js/modal';
import scrollTriggerFunctions from './src/js/scrollTriggerFunctions';
import backToTop from './src/js/backToTop';
// Import Slick Carousel Styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import Slick Carousel JS
import 'slick-carousel';
import $ from 'jquery'; // Slick depends on jQuery
import 'slick-carousel/slick/slick.js';


const toggleFindaschool = document.getElementById('findaschool');
const toggleMyschool = document.getElementById('myschool');
const toggleCommunity= document.getElementById('community');
const mobile = document.getElementById('mobile');
const mobiles = document.getElementById('mobiles');
const mobiletwo = document.getElementById('mobiletwo');
const mobilestwo = document.getElementById('mobilestwo');
const closeMobilebtn = document.getElementById('closemobilebtn');
const closeMobilebtnTwo = document.getElementById('closeMobilebtnTwo');

const page_link_one = document.getElementById('page_link_one');
const page_link_two = document.getElementById('page_link_two');
const page_link_three = document.getElementById('page_link_three');
const page_link_four = document.getElementById('page_link_four');

if (toggleCommunity) {
    toggleCommunity.addEventListener('click', toggleCommunitytab);
}

function toggleCommunitytab() {
    if (page_link_one && page_link_two && page_link_three && page_link_four) {

        page_link_one.classList.toggle('hidden');
        page_link_two.classList.toggle('hidden');
        page_link_three.classList.toggle('hidden');
        page_link_four.classList.toggle('hidden');
    }
}


if (toggleFindaschool) {
    toggleFindaschool.addEventListener('click', toggleMobile);
}

if (toggleMyschool) {
    toggleMyschool.addEventListener('click', toggleMobileTwo);
}
if (closeMobilebtn) {
    closeMobilebtn.addEventListener('click', toggleMobile);
}

if (closeMobilebtnTwo) {
    closeMobilebtnTwo.addEventListener('click', toggleMobileTwo);
}

function toggleMobile() {
    if (mobile && mobiles && mobiletwo && mobilestwo) {
        // Hide mobiletwo and mobilestwo if they are visible
        if (!mobiletwo.classList.contains('hidden') || !mobilestwo.classList.contains('hidden')) {
            mobiletwo.classList.add('hidden');
            mobilestwo.classList.add('hidden');
        }
        // Toggle mobile and mobiles
        mobile.classList.toggle('hidden');
        mobiles.classList.toggle('hidden');
    }
}

function toggleMobileTwo() {
    if (mobiletwo && mobilestwo && mobile && mobiles) {
        // Hide mobile and mobiles if they are visible
        if (!mobile.classList.contains('hidden') || !mobiles.classList.contains('hidden')) {
            mobile.classList.add('hidden');
            mobiles.classList.add('hidden');
        }
        // Toggle mobiletwo and mobilestwo
        mobiletwo.classList.toggle('hidden');
        mobilestwo.classList.toggle('hidden');
    }
}




document.addEventListener("DOMContentLoaded", function () {
  var teamSwiper = new Swiper(".teamSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true, // optional: makes dots responsive and centered
    },
    breakpoints: {
      640: { slidesPerView: 2 },   // Tablet
      1024: { slidesPerView: 5 }   // Desktop
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
    const swiperSlides = document.querySelectorAll('.latestnews');
    let maxHeight = 0;
    const extraPadding = 20; // Adjust padding as needed

    // Loop through all .latestnews elements to find the tallest one
    swiperSlides.forEach(slide => {
        const slideHeight = slide.offsetHeight;
        if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
        }
    });

    // Set all .latestnews elements to the height of the tallest one + extra padding
    swiperSlides.forEach(slide => {
        slide.style.height = `${maxHeight + extraPadding}px`;
    });
});

  
document.addEventListener('DOMContentLoaded', () => {
    // Initialize the Slick carousel
    $('.slideshow').slick({
        infinite: true,
        pauseOnHover: false,
        autoplay: true,            // Enable auto slide
        autoplaySpeed: 3000,       // 3 seconds per slide
        slidesToShow: 1,           // Show 4 slides at a time
        slidesToScroll: 1,         // Scroll one slide at a time
        arrows: true,              // Enable navigation arrows
        dots: false, 
        fade: true,                // Enable fade transition
        cssEase: 'linear',    

    });
});




document.addEventListener('DOMContentLoaded', function () {
    const links = document.querySelectorAll('.location-link');
    const image = document.getElementById('map-image');
    const schoolListContainer = document.getElementById('school-list');
    
    const schoolList = document.getElementById('schools');
    const mapDiv = document.querySelector('.map'); // Get the map div container

    // Store the initial state
    const initialImage = image.src; // Save the first image
    const initialLinks = Array.from(links); // Save all location links

    // Create the popup container inside the map div
    const popupContainer = document.createElement('div');
    popupContainer.classList.add('popup-container');
    mapDiv.appendChild(popupContainer); // Append it to the map div

    // Create the reset button
    const resetButton = document.createElement('button');
    resetButton.textContent = 'Reset';
    resetButton.classList.add('reset-button');
    mapDiv.appendChild(resetButton); // Append reset button to the map div

    // Function to close the popup when clicked outside or pressing the ESC key
    function closePopup() {
        popupContainer.style.display = 'none'; // Hide the popup
    }

    // Close the popup when clicking outside of it
    popupContainer.addEventListener('click', function (event) {
        if (event.target === popupContainer) {
            closePopup();
        }
    });

    // Close the popup when pressing the ESC key
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closePopup();
        }
    });

    // Add event listeners to location links
    links.forEach(link => {
        link.addEventListener('click', function () {
            // Swap the map image
            const newImage = this.getAttribute('data-location-image');
            if (newImage) {
                image.src = newImage;
            }

            // Show the schools
            const schools = JSON.parse(this.getAttribute('data-schools'));
            schoolList.innerHTML = ''; // Clear previous list
            schools.forEach(school => {
                const li = document.createElement('li');
                li.textContent = ""; // Set the school name
                li.classList.add(school.class); // Add class from the sanitized name

                // Add event listener to each school name to open the popup
                li.addEventListener('click', function () {
                    const featuredImage = school.school_image ? school.school_image : ''; // Get the school image
                    const schoolName = school.title;

                    // Create the popup content
                    popupContainer.innerHTML = `
                        <div class="popup-content">
                            <img src="${featuredImage}" alt="${schoolName}" class="popup-image">
                            <h3>${schoolName}</h3>
                        </div>
                    `;

                    // Show the popup
                    popupContainer.style.display = 'block';
                });

                schoolList.appendChild(li);
            });

            // Show the school list container
            schoolListContainer.classList.remove('hidden');

            // Hide all location links initially
            links.forEach(l => l.style.display = 'none');

            // Logic for specific links
            if (this.textContent.trim() === 'Kenya') {
                // Show only "Nairobi"
                document.querySelectorAll('.location-link').forEach(link => {
                    if (link.textContent.trim() === 'Nairobi') {
                        link.style.display = 'block';
                    }
                });
            } else if (this.textContent.trim() === 'Nairobi' || this.textContent.trim() === 'Rwanda') {
                // Hide all links for "Nairobi" or "Rwanda"
                this.style.display = 'none';
            }
        });
    });

    // Reset button functionality
    const resetLinks = document.querySelectorAll('.resets');
    resetLinks.forEach(resetLink => {
        resetLink.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default link behavior
            location.reload(); // Refresh the page to reset everything
        });
    });
});

document.querySelectorAll('.location-link').forEach(link => {
    link.addEventListener('click', function() {
        const locationData = this.getAttribute('data-schools');
        
        // Parse the JSON data from the 'data-schools' attribute
        const schools = JSON.parse(locationData);
        
        // Trigger the AJAX request to load the schools for the clicked location
        loadSchools(schools);
    });
});




document.querySelectorAll('.location-link').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();

        const locationName = this.getAttribute('data-location-name');
        const schoolsData = this.getAttribute('data-schools');

        let schools;
        try {
            schools = JSON.parse(schoolsData);
        } catch (error) {
            console.error('Failed to parse schools data:', error);
            return;
        }

        console.log('Schools data:', schools); // Log the schools data to ensure it's correct

        const displayContainer = document.getElementById('school-display');
        if (!displayContainer) {
            console.error('Error: school-display container not found.');
            return;
        }

        // Build the filtered schools HTML
        let schoolHTML = `
            <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-10 mx-5 lg:mx-10 my-10 md:mx-10 sm:mx-10">
        `;

        schools.forEach(school => {
            schoolHTML += `
                <div class="group">
                    <a href="${school.permalink}" class="curriculum-box bg-white border-2 border-secondary group-hover:scale-110 transition-all duration-300 h-full flex flex-col">
                        ${school.school_image ? `
                            <div class="curriculum-image bg-cover bg-center h-[150px] w-full" 
                                 style="background-image: url('${school.school_image}');">
                            </div>
                        ` : ''}
                        <div class="py-2 px-4 border-t-2 border-secondary flex-grow flex flex-col">
                            <h3 class="text-xl text-center">${school.title}</h3>
                            ${school.countries.length ? `
                                <p class="text-center text-base">${school.countries.join(', ')}</p>
                            ` : ''}
                        </div>
                    </a>
                </div>
            `;
        });

        schoolHTML += `</div>`;

        console.log('Generated HTML:', schoolHTML); // Log the generated HTML string

        // Update the school display container
        displayContainer.innerHTML = schoolHTML;
    });
});





document.addEventListener('DOMContentLoaded', function() {
    const locationLinks = document.querySelectorAll('.location-link');

    locationLinks.forEach(link => {
        link.addEventListener('click', function() {
            const locationName = link.innerText.trim(); // Get the location name from the link text
            const sanitizedLocationName = locationName.replace(/\s+/g, '-').toLowerCase(); // Ensure it matches the class format
            const schoolList = document.querySelector('.school-list-' + sanitizedLocationName);

            // Check if the school list exists and toggle visibility
            if (schoolList) {
                if (schoolList.style.display === 'none' || schoolList.style.display === '') {
                    schoolList.style.display = 'block';
                } else {
                    schoolList.style.display = 'none';
                }
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const el = document.querySelector('.reviews');
    if (!el) return;
    const count = parseInt(el.dataset.count || '0', 10);
    const perView = Math.min(4, count || 4);

    new Swiper(el, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        watchOverflow: true,
        breakpoints: {
            640:  { slidesPerView: 1 },
            768:  { slidesPerView: Math.min(2, perView) },
            1024: { slidesPerView: perView },
            1280: { slidesPerView: perView },
        },
        pagination: { el: '.swiper-paginationr', clickable: true },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Initialize the Slick carousel
    $('.highlights-carousel').slick({
        infinite: true,
        pauseOnHover: false,
        autoplay: true,            // Enable auto slide
        autoplaySpeed: 3000,       // 3 seconds per slide
        slidesToShow: 4,           // Show 4 slides at a time
        slidesToScroll: 1,         // Scroll one slide at a time
        arrows: false,              // Enable navigation arrows
        dots: true,     
                   // Enable pagination dots
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2, // Show 3 slides on medium screens
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1, // Show 2 slides on small screens
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1, // Show 1 slide on very small screens
                },
            },
        ],
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Initialize the Slick carousel
    $('.logo-carousel').slick({
        infinite: true,
        pauseOnHover: false,
        autoplay: true,            // Enable auto slide
        autoplaySpeed: 3000,       // 3 seconds per slide
        slidesToShow: 4,           // Show 4 slides at a time
        slidesToScroll: 1,         // Scroll one slide at a time
        arrows: true,              // Enable navigation arrows
        dots: false,     
                   // Enable pagination dots
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3, // Show 3 slides on medium screens
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2, // Show 2 slides on small screens
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2, // Show 1 slide on very small screens
                },
            },
        ],
    });
});


document.addEventListener('DOMContentLoaded', () => {
    // Initialize the Slick carousel
    $('.custom-swiper-wrappers').slick({
        infinite: true,
        pauseOnHover: false,
        autoplay: true,            // Enable auto slide
        autoplaySpeed: 3000,       // 3 seconds per slide
        slidesToShow: 3,           // Show 4 slides at a time
        slidesToScroll: 1,         // Scroll one slide at a time
        arrows: true,              // Enable navigation arrows
        dots: false,     
                   // Enable pagination dots
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2, // Show 3 slides on medium screens
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2, // Show 2 slides on small screens
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1, // Show 1 slide on very small screens
                },
            },
        ],
    });
});

document.addEventListener('DOMContentLoaded', () => {
  // Initialize the Slick carousel
  $('.custom-swiper-wrapper').slick({
    infinite: true,
    pauseOnHover: false, 
    autoplay: true,               // Enable auto slide
    autoplaySpeed: 3000,
    slidesToShow: 1,  // Change this as needed
    slidesToScroll: 1,
    arrows: false,  // Enable navigation arrows
    dots: false,    // Enable pagination
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});



backToTop();
scrollTriggerFunctions();
menuToggle();
menuDropdown();
modal();

/**
 * Latest News & Events
 * -------------------------------------------------------------------------
 * 1. Subdomain filter dropdown -> reloads with ?subdomain=N
 * 2. Load more: 9 cards visible on desktop (>=1024px), 3 on mobile, +3 per click
 *
 * Vanilla JS - no jQuery dependency. Safe to paste into a shared scripts file;
 * it exits immediately on pages that don't have the markup.
 */
(function () {
	'use strict';

	/* --- Subdomain filter --------------------------------------------- */
	function initFilter() {
		var select = document.getElementById('subdomain-select');
		if (!select) { return; }

		select.addEventListener('change', function () {
			var url = new URL(window.location.href);
			if (this.value === 'all') {
				url.searchParams.delete('subdomain');
			} else {
				url.searchParams.set('subdomain', this.value);
			}
			window.location.href = url.toString();
		});
	}

	/* --- Load more ----------------------------------------------------- */
	function initLoadMore() {
		var container = document.getElementById('news-posts-grid');
		var button    = document.getElementById('news-load-more');
		var wrap      = document.getElementById('news-load-more-wrap');
		if (!container || !button) { return; }

		// The theme's load-more-posts.js binds to #load-more-btn and, on its
		// first click, fires its own AJAX, sets the label to "No More Posts"
		// and disables the button. A disabled button fires no click events at
		// all, which killed every subsequent click. The IDs here are renamed so
		// that script can no longer find this button or grid.
		//
		// Belt and braces: if anything ever disables it again, undo that.
		button.disabled = false;
		button.removeAttribute('disabled');

		var initialMobile  = parseInt(container.getAttribute('data-initial-mobile'), 10)  || 3;
		var initialDesktop = parseInt(container.getAttribute('data-initial-desktop'), 10) || 9;
		var step           = parseInt(container.getAttribute('data-step'), 10)            || 3;

		var mq      = window.matchMedia('(min-width: 1024px)');
		var visible = 0;

		container.classList.add('js-ready');

		// Re-read the cards each time instead of caching the array, so this
		// survives anything that rewrites the container.
		function cards() {
			return container.querySelectorAll('.news-card');
		}

		function paint() {
			var list = cards();
			for (var i = 0; i < list.length; i++) {
				list[i].style.display = (i < visible) ? '' : 'none';
			}
			if (wrap) {
				wrap.style.display = (visible >= list.length) ? 'none' : '';
			}
			if (window.NEWS_DEBUG) {
				console.log('[news] visible ' + visible + ' of ' + list.length);
			}
		}

		function reset() {
			visible = Math.min(mq.matches ? initialDesktop : initialMobile, cards().length);
			paint();
		}

		button.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			visible = Math.min(visible + step, cards().length);
			paint();
		});

		if (mq.addEventListener) { mq.addEventListener('change', reset); }
		else if (mq.addListener) { mq.addListener(reset); }

		reset();
	}

	function boot() {
		initFilter();
		initLoadMore();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
}());
document.addEventListener('DOMContentLoaded', function () {
    const filterForm = document.getElementById('filter-form');

    // Update URL parameters
    function updateURLParameter(param, value) {
        const url = new URL(window.location.href);
        if (value) {
            url.searchParams.set(param, value); // Add or update parameter
        } else {
            url.searchParams.delete(param); // Remove parameter if value is empty
        }
        window.history.pushState({}, '', url); // Update the URL
    }

    // Listen for changes in the dropdown fields
    filterForm.addEventListener('change', function (e) {
        if (e.target.tagName === 'SELECT') {
            const paramName = e.target.name;
            const paramValue = e.target.value;
            updateURLParameter(paramName, paramValue);

            // Reload the page to apply the filter
            window.location.reload();
        }
    });
}); 
document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('.swiper-wrapper');
    const slides = swiperContainer.children;

    // Duplicate slides until we have enough for looping
 // if (slides.length < 10) {
//      const requiredDuplicates = 10 - slides.length;
//      for (let i = 0; i < requiredDuplicates; i++) {
 //         const duplicate = slides[i % slides.length].cloneNode(true);
 //         swiperContainer.appendChild(duplicate);
 //     }
//  }

    // Initialize Swiper
    new Swiper('.swiper-container', {
        loop: false,
        slidesPerView: 1,
   
        centeredSlides: true,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            
        },
        breakpoints: {
            480: {
                slidesPerView: 1,
                centeredSlides: false, 
                spaceBetween: 20,
            },
            640: { 
                slidesPerView: 1,
         
            },
            768: { slidesPerView: 2 },
            1170: { slidesPerView: 4, centeredSlides: false },
        },
        rtl: true, 
 
    });
});








document.addEventListener('DOMContentLoaded', function () {
    // Left Column Swiper
    new Swiper('.history-slider', {
        loop: true,
        autoplay: {
            delay: 3000, // Auto-slide every 3 seconds
            disableOnInteraction: false, // Continue autoplay after interaction
        },
        speed: 1000, // Smooth fade transition
        effect: 'fade', // Fade effect
        fadeEffect: {
            crossFade: true, // Smooth fade
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Right Column Swiper with Pagination
    new Swiper('.history-info-slider', {
        loop: true,
        pagination: {
            el: '.swiper-pagination-text',
            clickable: true,
        },
        slidesPerView: 1, // Ensure only one slide is displayed at a time
        spaceBetween: 20, // Adjust spacing between slides if needed
    });
});


document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.group-members-slider', {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                slidesPerView: 6,
            },
        },
        pagination: {
            el: '.swiper-pagination-member',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.custom-swiper[data-swiper-id]');

  carousels.forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;

    const id = carousel.dataset.swiperId;

    new Swiper(`#${id}`, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      wrapperClass: 'custom-wrapper',   // ✅ custom class
      slideClass: 'custom-slide',       // ✅ custom class
      pagination: {
        el: `#${id} .custom-pagination`,
        clickable: true
      }
    });

    carousel.dataset.initialized = 'true';
  });
});







 document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".instagram-swiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      pagination: {
        el: ".swiper-paginationr",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 1
        },
        1024: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        }
      }
    });
  });

document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".facebook-swiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-paginationr",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 1
        },
        1024: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        }
      }
    });
  });






  document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(".accordion-header");

    headers.forEach(header => {
        header.addEventListener("click", () => {
            const content = header.nextElementSibling;
            const icon = header.querySelector(".accordion-icon");

            // Close all other accordions
            headers.forEach(h => {
                const otherContent = h.nextElementSibling;
                const otherIcon = h.querySelector(".accordion-icon");

                if (h !== header) {
                    otherContent.classList.add("hidden");
                    otherIcon.classList.remove("rotate-180");
                    otherIcon.classList.add("rotate-0");
                }
            });

            // Toggle current accordion
            const isOpen = !content.classList.contains("hidden");

            // Close current if open
            if (isOpen) {
                content.classList.add("hidden");
                icon.classList.remove("rotate-180");
                icon.classList.add("rotate-0");
            } 
            // Open current
            else {
                content.classList.remove("hidden");
                icon.classList.remove("rotate-0");
                icon.classList.add("rotate-180");
            }
        });
    });
});



const visionSection = document.getElementById('vision-section');
const missionSection = document.getElementById('mission-section');

const visionSection2 = document.getElementById('vision-section2');
const missionSection2 = document.getElementById('mission-section2');

// Get the buttons for toggling sections
const toggleVisionBtn = document.getElementById('toggle-vision-btn');
const toggleMissionBtn = document.getElementById('toggle-mission-btn');

const toggleVisionBtn2 = document.getElementById('toggle-vision-btn2');
const toggleMissionBtn2 = document.getElementById('toggle-mission-btn2');

// Get the close buttons
const closeVisionBtn = document.getElementById('close-vision-btn');
const closeMissionBtn = document.getElementById('close-mission-btn');

const closeVisionBtn2 = document.getElementById('close-vision-btn2');
const closeMissionBtn2 = document.getElementById('close-mission-btn2');



// Function to show the Vision section and hide the Mission section
function showVision() {
  visionSection.classList.remove('hidden');
  missionSection.classList.add('hidden');
}

function showVision2() {
    visionSection2.classList.remove('hidden');
    missionSection2.classList.add('hidden');
  }

// Function to show the Mission section and hide the Vision section
function showMission() {
  missionSection.classList.remove('hidden');
  visionSection.classList.add('hidden');
}

function showMission2() {
    missionSection2.classList.remove('hidden');
    visionSection2.classList.add('hidden');
  }

// Event listeners to toggle sections
toggleVisionBtn.addEventListener('click', showVision);
toggleMissionBtn.addEventListener('click', showMission);

toggleVisionBtn2.addEventListener('click', showVision2);
toggleMissionBtn2.addEventListener('click', showMission2);

// Close buttons for each section
closeVisionBtn.addEventListener('click', () => {
  visionSection.classList.add('hidden');
});

closeMissionBtn.addEventListener('click', () => {
  missionSection.classList.add('hidden');
}); 

closeVisionBtn2.addEventListener('click', () => {
    visionSection2.classList.add('hidden');
  });
  
closeMissionBtn2.addEventListener('click', () => {
    missionSection2.classList.add('hidden');
  }); 

